import React, { useEffect, useState } from "react";
import { Button, Col, InputGroup, Row } from "react-bootstrap";
import "./IngresoManual.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { v4 as uuidv4 } from "uuid";
import {
  faMinus,
  faPlus,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";
import VentanaMovible from "../../VentanaMovible";

const PlatilloTurnero = ({
  platillo,
  anadidos,
  ingredientes,
  detalleorden,
  agregar,
  sumCantidad,
  resCantidad,
  remove,
  item,
  handleNote,
}) => {
  const [costosItems, setCostosItems] = useState([]);
  const [selectCostosItem, setSelectCostosItem] = useState(null);

  const handleAgregar = (plati) => {
    if (!selectCostosItem) {
      alert("Seleccione una presentacion del platillo.");
      return;
    }
    let flag = 0;
    let totalAnadidos = 0.0;
    if (
      plati.categoriasPers &&
      plati.categoriasPers.length > 0 &&
      plati.personalizable
    ) {
      plati.categoriasPers.forEach((val) => {
        let suma = 0;
        Object.keys(plati.listaingredientes)
          .filter((e) => plati.listaingredientes[e].categoria === val.nombre)
          .forEach((key) => {
            suma += parseInt(plati.listaingredientes[key].cantidad);
            if (val.precios && Object.keys(val.precios).includes(key)) {
              totalAnadidos +=
                parseFloat(val.precios[key]) *
                parseInt(plati.listaingredientes[key].cantidad);
              plati.listaingredientes[key].costo = parseFloat(val.precios[key]);
            } else {
              plati.listaingredientes[key].costo = 0;
            }
          });
        if (flag === 0 && suma < parseInt(val.ingredientes)) {
          alert("Selecciona la cantidad indicada para " + val.nombre + ".");
          flag++;
        }
      });
    }
    if (flag !== 0) {
      return;
    }

    if (plati.anadidos) {
      Object.keys(plati.anadidos).forEach((key) => {
        totalAnadidos +=
          parseFloat(plati.anadidos[key].cantidad) *
          parseFloat(plati.anadidos[key].precio);
      });
    }

    const updatedPlatillo = {
      cantidad: 1,
      costo: selectCostosItem.costo,
      description: plati.description,
      id: plati.id,
      idv4: uuidv4(),
      img: plati.img,
      name: plati.name,
      ncosto: selectCostosItem.ncosto,
      note: "",
      anadidos: plati.anadidos,
      ingredientes: plati.listaingredientes,
      npuntos: selectCostosItem.puntos,
      status: "PENDIENTE",
      totalAnadidos: totalAnadidos,
      total: selectCostosItem.costo * 1,
      puntos: selectCostosItem.puntos * 1,
    };
    if (selectCostosItem.puntos) {
      updatedPlatillo.npuntos = selectCostosItem.puntos;
      updatedPlatillo.puntos = selectCostosItem.puntos * 1;
    } else {
      updatedPlatillo.npuntos = 0;
      updatedPlatillo.puntos = 0;
    }
    agregar(updatedPlatillo);
  };

  const platinorder = item.find((ite) => {
    return (
      selectCostosItem &&
      ite.id === platillo.id &&
      ite.costo === selectCostosItem.costo &&
      ite.ncosto === selectCostosItem.ncosto
    );
  });

  useEffect(() => {
    if (platillo) {
      platillo.anadidos = {};
      platillo.listaingredientes = {};
      // if (platillo.especificos && platillo.ingesp) {
      //   setIngredientesMostrar(
      //     ingredientes.filter((e) => platillo.ingesp.includes(e.id)),
      //   );
      // } else {
      //   setIngredientesMostrar(ingredientes);
      // }
      let costos = [];
      if (platillo.ncosto1 && parseFloat(platillo.costo1) > 0) {
        costos.push({
          ncosto: platillo.ncosto1,
          costo: platillo.costo1,
          puntos: platillo.puntos1,
        });
      }
      if (platillo.ncosto2 && parseFloat(platillo.costo2) > 0) {
        costos.push({
          ncosto: platillo.ncosto2,
          costo: platillo.costo2,
          puntos: platillo.puntos2,
        });
      }
      if (platillo.ncosto3 && parseFloat(platillo.costo3) > 0) {
        costos.push({
          ncosto: platillo.ncosto3,
          costo: platillo.costo3,
          puntos: platillo.puntos3,
        });
      }
      setSelectCostosItem(costos[0]);
      setCostosItems(costos);
    }
  }, [platillo]);

  return (
    <Col md={3}>
      <div
        style={{
          height: "100%",
          // display: "flex",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 8,
          marginBottom: 8,
        }}
      >
        <h6 style={{ fontWeight: "bold" }}>{platillo.name}</h6>
        <div style={{ height: "11rem", alignContent: "center" }}>
          {costosItems.length > 1 ? (
            <>
              {costosItems.map((item, index) => (
                <Row
                  style={{
                    alignContent: "space-between",
                    borderStyle: "solid",
                    borderRadius: 10,
                    borderWidth: 0.5,
                    marginLeft: 30,
                    marginRight: 30,
                    marginBottom: 5,
                  }}
                  onClick={() => {
                    setSelectCostosItem(item);
                  }}
                >
                  <Col md={8} style={{ textAlign: "left", fontWeight: "bold" }}>
                    {item.ncosto} <br />${parseFloat(item.costo).toFixed(2)}
                  </Col>
                  <Col md={4} style={{ alignContent: "center" }}>
                    <input
                      type="radio"
                      key={item.ncosto}
                      style={{ color: "#00640D" }}
                      item={item}
                      checked={item === selectCostosItem}
                      onClick={() => {
                        setSelectCostosItem(item);
                      }}
                    />
                  </Col>
                </Row>
              ))}
            </>
          ) : (
            <>
              <img
                src={platillo.img}
                alt=""
                width={"120rem"}
                height={"130rem"}
                style={{ objectFit: "contain" }}
              />
              <h6 style={{ fontWeight: "bold" }}>
                ${parseFloat(costosItems[0]?.costo).toFixed(2)}
              </h6>
            </>
          )}
        </div>
        {platillo.personalizable || platillo.agregadosObligatorios ? (
          <VentanaMovible
            platillo={platillo}
            anadidos={anadidos}
            ingredientes={ingredientes}
            detalleOrden={detalleorden}
            selectCostosItem={selectCostosItem}
            agregarplatillo={agregar}
          />
        ) : (
          <>
            {platinorder ? (
              <>
                <InputGroup
                  style={{
                    justifyContent: "center",
                    marginTop: 9,
                    marginBottom: 10,
                  }}
                >
                  <Button
                    variant="outline-dark"
                    onClick={() => {
                      remove(platinorder);
                    }}
                  >
                    <i
                      className="bx bx-trash icon"
                      style={{ fontSize: 20, color: "red" }}
                    ></i>
                  </Button>
                  <Button
                    variant="outline-dark"
                    onClick={() => {
                      resCantidad(platinorder);
                    }}
                  >
                    <FontAwesomeIcon icon={faMinus} style={{ fontSize: 13 }} />
                  </Button>
                  <InputGroup.Text
                    style={{ fontSize: 13, borderColor: "#000000" }}
                  >
                    {platinorder.cantidad}
                  </InputGroup.Text>
                  <Button
                    variant="outline-dark"
                    onClick={() => sumCantidad(platinorder)}
                  >
                    <FontAwesomeIcon icon={faPlus} style={{ fontSize: 13 }} />
                  </Button>
                </InputGroup>
                <VentanaMovible
                  platillo={platillo}
                  agregarNota={true}
                  selectCostosItem={selectCostosItem}
                  platinorder={platinorder}
                  handleNote={handleNote}
                />
              </>
            ) : (
              <Button
                variant="success"
                id="agregar"
                onClick={(e) => {
                  handleAgregar(platillo);
                }}
                style={{ width: "80%" }}
              >
                <FontAwesomeIcon icon={faShoppingCart} />
                Agregar
              </Button>
            )}
          </>
        )}
        <VentanaMovible
          platillo={platillo}
          verDetalle={true}
          selectCostosItem={selectCostosItem}
        />
      </div>
    </Col>
  );
};

export default PlatilloTurnero;
